// session.js — helper to get a stable session id
export function getOrCreateSessionId(datasetId) {
  if (!datasetId) return "default";
  const key = `agent:sid:${datasetId}`;
  try {
    let sid = window.localStorage.getItem(key);
    if (!sid) {
      sid =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `sid_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
      window.localStorage.setItem(key, sid);
    }
    return sid;
  } catch {
    return "default";
  }
}
